/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarkingTypeWithRelations } from '../../models/marking-type-with-relations';

export interface GetMarkingTypesList$Params {
}

export function getMarkingTypesList(http: HttpClient, rootUrl: string, params?: GetMarkingTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MarkingTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getMarkingTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MarkingTypeWithRelations>>;
    })
  );
}

getMarkingTypesList.PATH = '/marking-types';
